import AuditChangeDetails from '../../../utils/AuditChangeDetails';
import { parseDetail, summary as auditSummary, humanText, detailForRow } from '../../../utils/auditPresentation';
import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import {Box, Button, Avatar, Typography} from "@mui/material";
import moment from "moment-timezone";
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  AUDIT_REPORT_SORT_MAP,
  withClickableCell,
} from "../../grid/iLocalAGGrid";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import AppBar from "@mui/material/AppBar";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";

class EnhancedTableHead extends React.Component {
  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      {
        id: "first_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.Transaction.FirstName"),
        padding: "10px",
        field: "first_name",
      },
      {
        id: "last_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.Transaction.LastName"),
        padding: "10px",
        field: "last_name",
      },
      // {
      //   id: "stock_code",
      //   numeric: false,
      //   disablePadding: false,
      //   label: t("Report.Transaction.StockCode"),
      //   padding: "10px",
      //   field: "stock_code",
      // },
      // {
      //   id: "pucode",
      //   numeric: false,
      //   disablePadding: false,
      //   label: t("Report.Transaction.PUCode"),
      //   padding: "10px",
      //   field: "pucode",
      // },
      { id: "store_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Store"), padding: '10px', field: 'store_name' },
      { id: "location_name", numeric: false, disablePadding: false, label: t("Report.phiLogs.Location"), padding: '10px', field: 'location_name' },
      { id: "action_name", numeric: false, disablePadding: false, label: t("Report.auditTrail.action_title"), padding: '10px', field: 'action_name' },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: t("Location.Description"),
        padding: "10px",
        field: "description",
      },
      { id: "username", numeric: false, disablePadding: false, label: t("Report.inActive.UserName"), padding: '10px', field: 'username' },
      {
        id: "created_on",
        numeric: false,
        disablePadding: false,
        label: t("Report.phiLogs.CreatedOn"),
        padding: "10px",
        field: "created_on",
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: "rgba(0, 0, 0, 0.54)" }}
              >
                {
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                }
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = (theme) => ({
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  dob: {
    paddingTop: "25px",
  },
  headerdiv: {
    paddingLeft: "15%",
    paddingTop: "10",
  },
  padding10px: {
    padding: "8px",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: "absolute",
    width: "89%",
    height: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255,255,255,0.5)",
    zIndex: "7869",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: "",
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  timezone: ""
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class AuditReportComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: "",
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: "",
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      selectedObject: {},
      isButtonDisabled: false,
      locale: localStorage.getItem("i18nextLng") === "en" ? enLocale : frLocale,
    };
    this.debouceTimeout = null;
  }

  componentDidMount() {
    // Get user's timezone for date filtering
    let userTimeZone = sessionStorage.getItem('timeZone');
    if (['null', null, 'undefined', undefined, ''].includes(userTimeZone)) {
      userTimeZone = defaultZone;
    }
    TransactionFilterObj.timezone = userTimeZone.substring(userTimeZone.lastIndexOf(' ') + 1);
    
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const {t} = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(TransactionFilterObj, {
      store_ids: [],
      box_ids: [],
      searchtext: "",
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: "desc",
      sortColumn: "created_on",
      tableName: "",
      timezone: TransactionFilterObj.timezone // Preserve timezone
    });
}

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("MM/DD/YYYY hh:mm:ss A")
      : date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("DD/MM/YYYY hh:mm:ss A");
  };

  extractAudioDeviceInfo = (description) => {
    if (!description) return null;
    
    try {
      // Look for audio device information in the description
      const audioDeviceMatch = description.match(/\[AUDIO_DEVICE_INFO:(.+?)\]/);
      if (!audioDeviceMatch) return null;
      
      const deviceInfoJson = audioDeviceMatch[1];
      return JSON.parse(deviceInfoJson);
    } catch (error) {
      console.warn('Failed to extract audio device information:', error);
      return null;
    }
  };

  extractCameraDeviceInfo = (description) => {
    if (!description) return null;
    
    try {
      // Look for camera device information in the description
      const cameraDeviceMatch = description.match(/\[CAMERA_DEVICE_INFO:(.+?)\](?=\s*\[|$)/);
      if (!cameraDeviceMatch) return null;
      
      const deviceInfoJson = cameraDeviceMatch[1];
      return JSON.parse(deviceInfoJson);
    } catch (error) {
      console.warn('Failed to extract camera device information:', error);
      return null;
    }
  };

  getCleanDescription = (description) => {
    if (!description) return description;
    
    // Remove all tags from description for clean display
    return description
      .replace(/\[AUDIO_DEVICE_INFO:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[CAMERA_DEVICE_INFO:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[EVENT:[^\]]*\]/g, '')
      .replace(/\[SOURCE:[^\]]*\]/g, '')
      .replace(/\[SEVERITY:[^\]]*\]/g, '')
      .replace(/\[METADATA:[^\]]*\]/g, '')
      .replace(/\[PUCODE:[^\]]*\]/g, '')
      .replace(/\[ACTOR:[^\]]*\]/g, '')
      .replace(/\[VERSION:[^\]]*\]/g, '')
      .replace(/\[BROWSER:[^\]]*\]/g, '')
      .replace(/\[LOGIN_METHOD:[^\]]*\]/g, '')
      .replace(/\[BROWSER_DETAILS:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[BROWSER_CHANGES:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .replace(/\[PERMISSION_CHANGES:\{[\s\S]*?\}\](?=\s*\[|$)/g, '')
      .trim();
  };

  parsePermissionChanges = (description = '') => {
    if (!description) {
      return null;
    }

    try {
      const structuredMatch = description.match(/\[PERMISSION_CHANGES:(\{[\s\S]*?\})\](?=\s*\[|$)/);
      if (structuredMatch) {
        return JSON.parse(structuredMatch[1]);
      }
    } catch (error) {
      console.warn('Failed to parse structured permission changes:', error);
    }

    const cleanDescription = description
      .replace(/\[VERSION:[^\]]*\]/g, '')
      .replace(/\[BROWSER:[^\]]*\]/g, '')
      .replace(/\[LOGIN_METHOD:[^\]]*\]/g, '')
      .replace(/\[SOURCE:[^\]]*\]/g, '')
      .replace(/\[SEVERITY:[^\]]*\]/g, '')
      .trim();

    const pushMatch = cleanDescription.match(
      /Permissions pushed from account '([^']*)' \(role '([^']*)'\) to account '([^']*)' \(role '([^']*)'\)/i
    );
    if (pushMatch) {
      return {
        type: 'push',
        fromAccount: pushMatch[1],
        toAccount: pushMatch[3],
        fromRole: pushMatch[2],
        toRole: pushMatch[4],
      };
    }

    const pushMatchShort = cleanDescription.match(
      /Permissions pushed from '([^']*)' to '([^']*)'/i
    );
    if (pushMatchShort) {
      return {
        type: 'push',
        fromAccount: pushMatchShort[1],
        toAccount: pushMatchShort[2],
      };
    }

    const roleMatch = cleanDescription.match(
      /Role permissions updated for account '([^']*)' and role '([^']*)/
    );
    if (!roleMatch) {
      return null;
    }

    const granted = [];
    const revoked = [];
    const grantedMatch = cleanDescription.match(/granted:\s*([^;]+)/i);
    const revokedMatch = cleanDescription.match(/revoked:\s*([^;.]+)/i);

    if (grantedMatch && grantedMatch[1].trim()) {
      granted.push(...grantedMatch[1].split(',').map((item) => item.trim()).filter(Boolean));
    }
    if (revokedMatch && revokedMatch[1].trim()) {
      revoked.push(...revokedMatch[1].split(',').map((item) => item.trim()).filter(Boolean));
    }

    const cascadeMatch = cleanDescription.match(/(with cascade to child accounts[^:]*)/i);

    return {
      type: 'role',
      account: roleMatch[1],
      role: roleMatch[2],
      cascade: cascadeMatch ? cascadeMatch[1].trim() : null,
      granted,
      revoked,
    };
  };

  getPermissionDetails = (auditRow) => {
    if (!auditRow || !auditRow.description) {
      return null;
    }

    const permissionChanges = this.parsePermissionChanges(auditRow.description);
    if (!permissionChanges) {
      return null;
    }

    return permissionChanges;
  };

  renderPermissionChip = (label, background, color, chipKey) => (
    <span
      key={chipKey || label}
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 500,
        backgroundColor: background,
        color,
        margin: "4px",
      }}
    >
      {label}
    </span>
  );

  normalizePermissionEntry = (entry) => {
    if (typeof entry === 'string') {
      return { label: entry, category: 'Other' };
    }

    return {
      label: entry.label || entry.name || 'Unknown',
      category: entry.category || 'Other',
    };
  };

  groupPermissionsByCategory = (entries = []) => {
    const grouped = new Map();

    entries.forEach((entry) => {
      const normalized = this.normalizePermissionEntry(entry);
      if (!grouped.has(normalized.category)) {
        grouped.set(normalized.category, []);
      }
      grouped.get(normalized.category).push(normalized.label);
    });

    return grouped;
  };

  getCascadeLabel = (cascade) => {
    if (!cascade) {
      return null;
    }

    if (typeof cascade === 'object' && cascade.applied) {
      const count = cascade.accountCount || (cascade.accountNames && cascade.accountNames.length) || 0;
      if (cascade.accountNames && cascade.accountNames.length > 0) {
        return `Cascaded to ${count} child account${count === 1 ? '' : 's'}: ${cascade.accountNames.join(', ')}`;
      }
      if (count > 0) {
        return `Cascaded to ${count} child account${count === 1 ? '' : 's'}`;
      }
      return 'Cascaded to child accounts';
    }

    if (typeof cascade === 'string' && /cascade/i.test(cascade)) {
      return 'Cascaded to child accounts';
    }

    return null;
  };

  renderGroupedPermissionList = (entries, chipBackground, chipColor) => {
    const hasCategories = entries.some(
      (entry) => typeof entry === 'object' && entry.category && entry.category !== 'Other'
    );

    if (!hasCategories) {
      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', ml: -0.5 }}>
          {entries.map((entry, index) => {
            const normalized = this.normalizePermissionEntry(entry);
            return this.renderPermissionChip(
              normalized.label,
              chipBackground,
              chipColor,
              `perm-${index}-${normalized.label}`
            );
          })}
        </Box>
      );
    }

    const grouped = this.groupPermissionsByCategory(entries);

    return Array.from(grouped.entries()).map(([category, labels]) => (
      <Box key={category} sx={{ mb: 1.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: '#37474f', mb: 0.5 }}>
          {category}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', ml: -0.5 }}>
          {labels.map((label) =>
            this.renderPermissionChip(
              label,
              chipBackground,
              chipColor,
              `${category}-${label}`
            )
          )}
        </Box>
      </Box>
    ));
  };

  formatPermissionChangesInfo = (permissionDetails) => {
    if (!permissionDetails) {
      return null;
    }

    if (permissionDetails.type === 'push') {
      return (
        <Box sx={{ mt: 3, p: 2, backgroundColor: '#f0f7ff', borderRadius: '8px' }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
            Push Permission Details
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <Box>
              <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>From Account</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>{permissionDetails.fromAccount}</Typography>
              {permissionDetails.fromRole && (
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Role: {permissionDetails.fromRole}
                </Typography>
              )}
            </Box>
            <Box>
              <Typography variant="body2" sx={{ color: '#666', mb: 0.5 }}>To Account</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>{permissionDetails.toAccount}</Typography>
              {permissionDetails.toRole && (
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Role: {permissionDetails.toRole}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      );
    }

    const granted = Array.isArray(permissionDetails.granted) ? permissionDetails.granted : [];
    const revoked = Array.isArray(permissionDetails.revoked) ? permissionDetails.revoked : [];
    const cascadeLabel = this.getCascadeLabel(permissionDetails.cascade);

    return (
      <Box sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fb', borderRadius: '8px' }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
          Role Permission Details
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          <Box sx={{ backgroundColor: '#e3f2fd', color: '#0d47a1', px: 1.5, py: 0.75, borderRadius: '12px', fontWeight: 600, fontSize: '13px' }}>
            Account: {permissionDetails.account}
          </Box>
          <Box sx={{ backgroundColor: '#ede7f6', color: '#4527a0', px: 1.5, py: 0.75, borderRadius: '12px', fontWeight: 600, fontSize: '13px' }}>
            Role: {permissionDetails.role}
          </Box>
          {cascadeLabel && (
            <Box sx={{ backgroundColor: '#fff3e0', color: '#e65100', px: 1.5, py: 0.75, borderRadius: '12px', fontWeight: 600, fontSize: '13px' }}>
              {cascadeLabel}
            </Box>
          )}
        </Box>

        {granted.length > 0 && (
          <Box sx={{ mb: revoked.length > 0 ? 2 : 0 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#2e7d32', mb: 0.5 }}>
              Granted ({granted.length})
            </Typography>
            {this.renderGroupedPermissionList(granted, '#e8f5e9', '#1b5e20')}
          </Box>
        )}

        {revoked.length > 0 && (
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#c62828', mb: 0.5 }}>
              Revoked ({revoked.length})
            </Typography>
            {this.renderGroupedPermissionList(revoked, '#ffebee', '#b71c1c')}
          </Box>
        )}

        {granted.length === 0 && revoked.length === 0 && (
          <Typography variant="body2" color="textSecondary">
            No individual permission changes were recorded.
          </Typography>
        )}
      </Box>
    );
  };

  formatAudioDeviceInfo = (audioDeviceInfo) => {
    if (!audioDeviceInfo) return null;
    
    try {
      const { ringingDevice, callingDevice, micInput } = audioDeviceInfo;
      
      // Helper to render device info (handles both old and new format)
      const renderDeviceInfo = (device, label) => {
        if (!device) return null;
        
        // New format with preferred/selected
        if (device.selected || device.preferred) {
          return (
            <div style={{ marginBottom: "10px" }}>
              <strong>{label}:</strong>
              <div style={{ marginLeft: "10px", fontSize: "13px" }}>
                {device.preferred && (
                  <div>
                    <span style={{ color: '#666' }}>Preferred: </span>
                    <span style={{ color: '#1976d2' }}>{device.preferred.deviceName || 'Unknown'}</span>
                  </div>
                )}
                <div>
                  <span style={{ color: '#666' }}>Selected: </span>
                  <span style={{ color: '#333', fontWeight: 'bold' }}>{(device.selected && device.selected.deviceName) || 'Default System Device'}</span>
                </div>
              </div>
            </div>
          );
        }
        
        // Old format (backward compatibility)
        return (
          <div style={{ marginBottom: "10px" }}>
            <strong>{label}:</strong><br />
            <span style={{ color: device.selectionType === 'default' ? '#666' : '#333' }}>
              {device.deviceName || 'Unknown'}
            </span>
          </div>
        );
      };
      
      return (
        <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "5px" }}>
          <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Audio Devices Information</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
            {renderDeviceInfo(ringingDevice, "Ringing Device")}
            {renderDeviceInfo(callingDevice, "Calling Device")}
            {renderDeviceInfo(micInput, "Microphone")}
          </div>
        </div>
      );
    } catch (error) {
      console.warn('Failed to parse audio device information:', error);
      return null;
    }
  };

  formatCameraDeviceInfo = (cameraDeviceInfo) => {
    if (!cameraDeviceInfo) return null;
    
    try {
      // Handle both old format (selectedCamera) and new format (preferred/selected)
      const { available, count, selectedCamera, preferred, selected, devices, error } = cameraDeviceInfo;
      
      // Determine which camera to highlight (new format uses 'selected', old format uses 'selectedCamera')
      const activeSelected = selected || selectedCamera;
      
      return (
        <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#f0f7ff", borderRadius: "5px" }}>
          <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Camera Information</h4>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            <div>
              <strong>Camera Available:</strong><br />
              <span style={{ color: available ? '#2e7d32' : '#c62828' }}>
                {available ? 'Yes' : 'No'}
              </span>
            </div>
            <div>
              <strong>Camera Count:</strong><br />
              <span>{count || 0}</span>
            </div>
            
            {/* New format: show preferred and selected separately */}
            {(preferred || selected) && (
              <div style={{ gridColumn: "1 / -1" }}>
                {preferred && (
                  <div style={{ marginBottom: "5px" }}>
                    <strong>Preferred Camera:</strong><br />
                    <span style={{ color: '#1976d2' }}>
                      {preferred.deviceName || 'Unknown'}
                    </span>
                  </div>
                )}
                {selected && (
                  <div>
                    <strong>Selected Camera:</strong><br />
                    <span style={{ color: '#333', fontWeight: 'bold' }}>
                      {selected.deviceName || 'Unknown'}
                    </span>
                  </div>
                )}
              </div>
            )}
            
            {/* Old format: show selectedCamera for backward compatibility */}
            {!selected && !preferred && selectedCamera && (
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Selected Camera:</strong><br />
                <span style={{ color: '#333' }}>
                  {selectedCamera.deviceName || 'Unknown'}
                </span>
              </div>
            )}
            
            {devices && devices.length > 0 && (
              <div style={{ gridColumn: "1 / -1" }}>
                <strong>Available Cameras:</strong><br />
                <ul style={{ margin: "5px 0", paddingLeft: "20px" }}>
                  {devices.map((device, index) => {
                    const isPreferred = preferred && preferred.deviceId === device.deviceId;
                    const isSelected = activeSelected && activeSelected.deviceId === device.deviceId;
                    
                    return (
                      <li key={index} style={{ 
                        color: isSelected ? '#333' : (isPreferred ? '#1976d2' : '#666'),
                        fontWeight: isSelected ? 'bold' : 'normal'
                      }}>
                        {device.deviceName}
                        {isSelected && ' (Selected)'}
                        {isPreferred && !isSelected && ' (Preferred)'}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
            {error && (
              <div style={{ gridColumn: "1 / -1", color: '#c62828' }}>
                <strong>Error:</strong> {error}
              </div>
            )}
          </div>
        </div>
      );
    } catch (error) {
      console.warn('Failed to parse camera device information:', error);
      return null;
    }
  };

  parseAuditMetadata = (description = "") => {
    if (!description) {
      return null;
    }

    try {
      const eventMatch = description.match(/\[EVENT:([A-Z0-9_]+)\]/i);
      const sourceMatch = description.match(/\[SOURCE:([A-Z0-9_]+)\]/i);
      const severityMatch = description.match(/\[SEVERITY:([A-Z0-9_]+)\]/i);
      const pucodeMatch = description.match(/\[PUCODE:([A-Z0-9_]+)\]/i);
      const actorMatch = description.match(/\[ACTOR:([A-Z0-9_]+)\]/i);
      const versionMatch = description.match(/\[VERSION:([^\]]+)\]/i);
      const browserMatch = description.match(/\[BROWSER:([^\]]+)\]/i);
      const loginMethodMatch = description.match(/\[LOGIN_METHOD:([^\]]+)\]/i);
      const browserDetailsMatch = description.match(/\[BROWSER_DETAILS:(\{[\s\S]*?\})\](?=\s*\[|$)/);
      const browserChangesMatch = description.match(/\[BROWSER_CHANGES:(\{[\s\S]*?\})\](?=\s*\[|$)/);
      const metadataMatch = description.match(/\[METADATA:(\{[\s\S]*\})\]/);

      let metadata = null;
      let browserDetails = null;
      let browserChanges = null;

      if (metadataMatch) {
        try { metadata = JSON.parse(metadataMatch[1]); } catch (_e) { /* ignore */ }
      }
      if (browserDetailsMatch) {
        try { browserDetails = JSON.parse(browserDetailsMatch[1]); } catch (_e) { /* ignore */ }
      }
      if (browserChangesMatch) {
        try { browserChanges = JSON.parse(browserChangesMatch[1]); } catch (_e) { /* ignore */ }
      }

      return {
        eventType: eventMatch ? eventMatch[1] : null,
        source: sourceMatch ? sourceMatch[1] : null,
        severity: severityMatch ? severityMatch[1] : null,
        pucode: pucodeMatch ? pucodeMatch[1] : null,
        actor: actorMatch ? actorMatch[1] : null,
        version: versionMatch ? versionMatch[1] : null,
        browser: browserMatch ? browserMatch[1] : null,
        loginMethod: loginMethodMatch ? loginMethodMatch[1] : null,
        browserDetails,
        browserChanges,
        metadata,
      };
    } catch (error) {
      console.warn("Failed to parse audit metadata", error);
      return null;
    }
  };

  getConsultDetails = (auditRow) => {
    if (!auditRow || !auditRow.description) {
      return null;
    }

    const parsed = this.parseAuditMetadata(auditRow.description);
    if (!parsed || parsed.eventType !== "PHARMACIST_EXPECTED_FOR_CONSULT" || !parsed.metadata) {
      return null;
    }

    const metadata = parsed.metadata || {};
    const recipients = Array.isArray(metadata.recipients) ? metadata.recipients : [];

    const onlineList =
      Array.isArray(metadata.onlineRecipients) && metadata.onlineRecipients.length > 0
        ? metadata.onlineRecipients
        : recipients.filter((r) => r.online).map((r) => r.username);

    const offlineList =
      Array.isArray(metadata.offlineRecipients) && metadata.offlineRecipients.length > 0
        ? metadata.offlineRecipients
        : recipients.filter((r) => !r.online).map((r) => r.username);

    const totalRecipients =
      typeof metadata.totalRecipients === "number" ? metadata.totalRecipients : recipients.length;
    const totalOnline =
      typeof metadata.totalOnline === "number" ? metadata.totalOnline : onlineList.length;
    const totalOffline =
      typeof metadata.totalOffline === "number" ? metadata.totalOffline : offlineList.length;

    return {
      pickupCode: metadata.pickupCode || "N/A",
      kioskName: metadata.kioskName || "",
      accountId: metadata.accountId || "",
      recipients,
      totalRecipients,
      totalOnline,
      totalOffline,
      onlineList,
      offlineList,
    };
  };

  renderStatusPill = (label, background, color) => (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 600,
        backgroundColor: background,
        color,
      }}
    >
      {humanText(label)}
    </span>
  );

  renderConsultDetails = (consultDetails) => {
    const { recipients, totalRecipients, totalOnline, totalOffline } = consultDetails;

    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Consult Attempt
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#1b5e20",
              fontWeight: 600,
              backgroundColor: "#e8f5e9",
              padding: "4px 10px",
              borderRadius: "999px",
              display: "inline-block",
            }}
          >
            Pickup {consultDetails.pickupCode}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#0d47a1",
              fontWeight: 600,
              backgroundColor: "#e3f2fd",
              padding: "4px 10px",
              borderRadius: "999px",
              display: "inline-block",
            }}
          >
            {consultDetails.kioskName || "Unknown kiosk"}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#e3f2fd",
              color: "#0d47a1",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Expected: {totalRecipients}
          </Box>
          <Box
            sx={{
              backgroundColor: "#e8f5e9",
              color: "#1b5e20",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Online: {totalOnline}
          </Box>
          <Box
            sx={{
              backgroundColor: "#fff3e0",
              color: "#e65100",
              padding: "8px 16px",
              borderRadius: "12px",
              fontWeight: 600,
            }}
          >
            Offline: {totalOffline}
          </Box>
        </Box>

        {totalRecipients === 0 ? (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            No pharmacists are currently associated with this store. Verify store assignments
            or consult toggles for the team.
          </Typography>
        ) : (
          <Table size="small" sx={{ mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Username</TableCell>
                <TableCell>Account</TableCell>
                <TableCell>Status</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>Last Active</TableCell>
                <TableCell>Consult Toggle</TableCell>
                <TableCell>Can Receive Call</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {recipients.map((recipient) => {
                const isOnline = Boolean(recipient.online);
                const isConsultEnabled = Boolean(recipient.persistedConsultEnabled);
                const hasToken = Boolean(recipient.hasPortalToken || recipient.hasMobileToken);
                const canNotify = isConsultEnabled && hasToken && isOnline;
                
                // Format last activity timestamp
                // Use lastLoginLogoutOn if available (includes presence_updated_at or last_login_on)
                // Fallback to lastLoginOn for backward compatibility
                const timestampToFormat = recipient.lastLoginLogoutOn || recipient.lastLoginOn;
                let lastActivityDisplay = "Never";
                
                if (timestampToFormat) {
                  try {
                    lastActivityDisplay = this.convertToTimeZone(timestampToFormat);
                  } catch (err) {
                    console.error('Error formatting last activity:', err);
                    // Try to display raw value if formatting fails
                    lastActivityDisplay = timestampToFormat instanceof Date 
                      ? timestampToFormat.toISOString() 
                      : String(timestampToFormat);
                  }
                }

                return (
                  <TableRow key={recipient.userId || recipient.username}>
                    <TableCell>{recipient.name || "—"}</TableCell>
                    <TableCell>{recipient.username || "—"}</TableCell>
                    <TableCell>{recipient.accountName || "—"}</TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        isOnline ? "Online" : "Offline",
                        isOnline ? "#e8f5e9" : "#fdecea",
                        isOnline ? "#1b5e20" : "#c62828"
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "13px",
                        }}
                      >
                        {lastActivityDisplay}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        isConsultEnabled ? "Enabled" : "Disabled",
                        isConsultEnabled ? "#e8f5e9" : "#eceff1",
                        isConsultEnabled ? "#1b5e20" : "#546e7a"
                      )}
                    </TableCell>
                    <TableCell>
                      {this.renderStatusPill(
                        canNotify ? "Yes" : "No",
                        canNotify ? "#e3f2fd" : "#fff3e0",
                        canNotify ? "#0d47a1" : "#e65100"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </Box>
    );
  };

  renderAuditMetadataDetails = (auditRow) => {
    const description = auditRow ? auditRow.description : undefined;
    const parsed = this.parseAuditMetadata(description);
    if (!parsed || (!parsed.eventType && !parsed.pucode && !parsed.actor && !parsed.version && !parsed.browser && !parsed.loginMethod && !parsed.browserDetails && !parsed.browserChanges && !(parsed.metadata && (parsed.metadata.orderId != null || parsed.metadata.binId != null)))) {
      return null;
    }

    const meta = parsed.metadata || {};

    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
          Audit Tags
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          {parsed.eventType && this.renderStatusPill(`Event: ${parsed.eventType}`, "#e3f2fd", "#0d47a1")}
          {parsed.pucode && this.renderStatusPill(`PUCODE: ${parsed.pucode}`, "#f3e5f5", "#7b1fa2")}
          {parsed.actor && this.renderStatusPill(`Actor: ${parsed.actor}`, "#e0f2f1", "#00695c")}
          {parsed.source && this.renderStatusPill(`Source: ${parsed.source}`, "#e8eaf6", "#283593")}
          {parsed.severity && this.renderStatusPill(`Severity: ${parsed.severity}`, "#fff3e0", "#e65100")}
          {parsed.version && this.renderStatusPill(`Version: ${parsed.version}`, "#e8f5e9", "#2e7d32")}
          {parsed.browser && this.renderStatusPill(`Browser: ${parsed.browser}`, "#fce4ec", "#c2185b")}
          {parsed.loginMethod && this.renderStatusPill(`Login: ${parsed.loginMethod}`, parsed.loginMethod === 'SSO' ? "#fff8e1" : "#e1f5fe", parsed.loginMethod === 'SSO' ? "#ff8f00" : "#0277bd")}
          {parsed.browserDetails && this.renderStatusPill(`Browser Details: Available`, "#f3e5f5", "#7b1fa2")}
          {parsed.browserChanges && this.renderStatusPill(`Browser Changes: Detected`, "#ffebee", "#c62828")}
          {meta.orderId != null && meta.orderId !== "" && this.renderStatusPill(`Order ID: ${meta.orderId}`, "#eceff1", "#455a64")}
          {meta.binId != null && meta.binId !== "" && this.renderStatusPill(`Bin: ${meta.binId}`, "#e8f5e9", "#2e7d32")}
        </Box>
      </Box>
    );
  };

  renderDescriptionSummary = (row) => {
    if (!row || !row.description) {
      return "";
    }

    const structured = parseDetail(row.description);
    if (structured || row.description.indexOf('\n[AUDIT_DETAIL_V1:') >= 0) return auditSummary(row.description);
    const parsed = this.parseAuditMetadata(row.description);
    if (parsed && parsed.eventType === "PHARMACIST_EXPECTED_FOR_CONSULT" && parsed.metadata) {
      const metadata = parsed.metadata;
      const recipients = Array.isArray(metadata.recipients) ? metadata.recipients : [];
      const total =
        typeof metadata.totalRecipients === "number" ? metadata.totalRecipients : recipients.length;
      const online =
        typeof metadata.totalOnline === "number"
          ? metadata.totalOnline
          : recipients.filter((r) => r.online).length;

      return `Consult attempt: ${total} pharmacist${total === 1 ? "" : "s"} expected (${online} online)`;
    }

    const permissionDetails = this.parsePermissionChanges(row.description);
    if (permissionDetails) {
      if (permissionDetails.type === 'push') {
        return `Permissions pushed from '${permissionDetails.fromAccount}' to '${permissionDetails.toAccount}'`;
      }

      const parts = [];
      if (permissionDetails.granted && permissionDetails.granted.length) {
        parts.push(`${permissionDetails.granted.length} granted`);
      }
      if (permissionDetails.revoked && permissionDetails.revoked.length) {
        parts.push(`${permissionDetails.revoked.length} revoked`);
      }
      const changeText = parts.length ? ` (${parts.join(', ')})` : '';
      return `Role permissions updated for '${permissionDetails.account}' / '${permissionDetails.role}'${changeText}`;
    }

    const clean = this.getCleanDescription(row.description);
    if (parsed && parsed.eventType) {
      return humanText(`${parsed.eventType.replace(/_/g, " ")}${clean ? ` · ${clean}` : ""}`);
    }

    return humanText(clean);
  };
  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000);
  };

  onFromDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  onToDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.setState({ loader: true });
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      sortMap: AUDIT_REPORT_SORT_MAP,
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['created_on'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "audit_report", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        // DI-6202: clear loader immediately (no delayed setTimeout) so the
        // audit trail does not stay on "Please Wait..." after data arrives.
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
          isButtonDisabled: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'created_on');
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

  handleDescriptionClick = (event, data) => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    this.setState({ detailDialogOpen: true, selectedObject: data });
  };

  handleDescriptionClose = (event) => {
    event.preventDefault();
    this.setState({ detailDialogOpen: false, selectedObject: {} });
  };

  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const {t} = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          //const boxvalues = boxlist;
          this.setState({ chipboxes: [], nboxes: [], boxvalues: boxvalues });
        });
    }

  }

  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    // If "All" is selected (regardless of other selections), show only "All" chip
    if (AllprocessedIndex > -1) {
      // Only show "All" chip
      chipprocessed = [this.state.accountValues[0]]; // "All" is always first item
      // But include all stores in processed for filtering
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      // Nothing selected
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      // Individual items selected (no "All")
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    // If "All" is selected (regardless of other selections), show only "All" chip
    if (AllprocessedIndex > -1) {
      // Only show "All" chip
      chipprocessed = [this.state.boxvalues[0]]; // "All" is always first item
      // But include all boxes in processed for filtering
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      // Nothing selected
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      // Individual items selected (no "All")
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }
    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Handle deletion of individual store chip
  handleDeleteStoreChip = (chipToDelete) => (event) => {
    event.stopPropagation();
    
    // If deleting "All" chip, clear everything
    if (chipToDelete.id === '-1') {
      this.setState({ 
        chipstores: [],
        nstores: [],
        store_id: []
      });
      
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      TransactionFilterObj.sortOrder = 'desc';
      TransactionFilterObj.sortColumn = 'created_on';
      TransactionFilterObj.tableName = '';
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    
    // Otherwise, remove individual chip
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    
    this.setState({ 
      chipstores: updatedStores,
      nstores: updatedNStores,
      store_id: updatedNStores.filter(s => s.id !== '-1').map(s => s.id)
    });
    
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Handle deletion of individual box chip
  handleDeleteBoxChip = (chipToDelete) => (event) => {
    event.stopPropagation();
    
    // If deleting "All" chip, clear everything
    if (chipToDelete.id === '-1') {
      this.setState({ 
        chipboxes: [],
        nboxes: [],
        box_id: []
      });
      
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      TransactionFilterObj.sortOrder = 'desc';
      TransactionFilterObj.sortColumn = 'created_on';
      TransactionFilterObj.tableName = '';
      this.BindGrid();
      return;
    }
    
    // Otherwise, remove individual chip
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    
    this.setState({ 
      chipboxes: updatedBoxes,
      nboxes: updatedNBoxes,
      box_id: updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id)
    });
    
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  // Clear all store selections
  handleClearAllStores = (event) => {
    event.stopPropagation();
    this.setState({ 
      chipstores: [],
      nstores: [],
      store_id: []
    });
    
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  // Clear all box selections
  handleClearAllBoxes = (event) => {
    event.stopPropagation();
    this.setState({ 
      chipboxes: [],
      nboxes: [],
      box_id: []
    });
    
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'created_on';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  render() {
    const {classes, t} = this.props;
    const selectedAudit = this.state.selectedObject || {};
    const structuredDetail = detailForRow(selectedAudit);
    const consultDetails = this.getConsultDetails(selectedAudit);
    const permissionDetails = this.getPermissionDetails(selectedAudit);
    const descriptionSummary = this.renderDescriptionSummary(selectedAudit);
    const hasUsername = Boolean(selectedAudit && selectedAudit.username);
    const hasEmail = Boolean(selectedAudit && selectedAudit.email);
    const hasPhone = Boolean(selectedAudit && selectedAudit.phone);
    const dialogTitle = structuredDetail
      ? (structuredDetail.kind === 'configuration' ? ((structuredDetail.target && structuredDetail.target.kind) || "Settings") + (structuredDetail.operation === 'create' ? " creation details" : " update details") : structuredDetail.kind === 'user' ? "User change details" : "Audit event details")
      : consultDetails
      ? "Consult Attempt Details"
      : permissionDetails
        ? (permissionDetails.type === 'push' ? "Push Permission Details" : "Role Permission Details")
        : "Audit details";
    
    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div id="react-no-print">
          <Dialog
            open={this.state.detailDialogOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: { borderRadius: "10px", width: "960px", maxWidth: "calc(100vw - 32px)", maxHeight: "90vh" },
            }}
          >
            <AppBar
              id="alert-dialog-title"
              position="static"
              color="default"
              sx={{
                backgroundColor: "#00a7e1",
                color: "white",
                padding: "4px",
                fontWeight: "bold",
              }}
            >
              {dialogTitle}
            </AppBar>
            <DialogContent id="alert-dialog-description" style={{ overflowX: "hidden", overflowWrap: "anywhere" }}>
              <div>
                {!structuredDetail && this.state.selectedObject.picture_url && this.state.selectedObject.picture_url !== "" && (
                  <Avatar
                    style={{ borderRadius: "2%", width: "150px", height: "150px", margin: "auto" }}
                    alt=""
                    src={this.state.selectedObject.picture_url}
                  />
                )}
                {!structuredDetail && hasUsername && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.UserName")} :
                    </span>
                    {selectedAudit.username}
                  </p>
                )}
                {!structuredDetail && hasEmail && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Email")} :
                    </span>
                    {selectedAudit.email}
                  </p>
                )}
                {!structuredDetail && hasPhone && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Users.Phone")} :
                    </span>
                    {selectedAudit.phone}
                  </p>
                )}
                {(((this.state.selectedObject && ![null, undefined, ''].includes(this.state.selectedObject.created_on))) && <p>
                  <span style={{ fontWeight: "bolder" }}>
                    {t("Users.DateTime")} :
                  </span>
                { this.convertToTimeZone(this.state.selectedObject.created_on) }
                </p>)}
                {!structuredDetail && descriptionSummary && (
                  <p>
                    <span style={{ fontWeight: "bolder" }}>
                      {t("Location.Description")} :
                    </span>
                    {descriptionSummary}
                  </p>
                )}
              </div>

              {structuredDetail && <AuditChangeDetails detail={structuredDetail} />}
              {!structuredDetail && this.renderAuditMetadataDetails(this.state.selectedObject)}

              {permissionDetails && this.formatPermissionChangesInfo(permissionDetails)}

              {consultDetails && this.renderConsultDetails(consultDetails)}
              
              {/* Display audio device information for consultation events */}
              {this.state.selectedObject && this.state.selectedObject.description && 
                this.state.selectedObject.action_name && 
                this.state.selectedObject.action_name.toLowerCase().includes('consultation') && 
                this.formatAudioDeviceInfo(this.extractAudioDeviceInfo(this.state.selectedObject.description))
              }
              
              {/* Display camera device information for consultation events */}
              {this.state.selectedObject && this.state.selectedObject.description && 
                this.state.selectedObject.action_name && 
                this.state.selectedObject.action_name.toLowerCase().includes('consultation') && 
                this.formatCameraDeviceInfo(this.extractCameraDeviceInfo(this.state.selectedObject.description))
              }

            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  this.handleDescriptionClose(e);
                }}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.Picked.Temperature.CloseButton")}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
<div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'first_name', headerName: t("Report.Transaction.FirstName"), colId: 'first_name' },
              { field: 'last_name', headerName: t("Report.Transaction.LastName"), colId: 'last_name' },
              { field: 'store_name', headerName: t("Report.phiLogs.Store"), colId: 'store_name' },
              { field: 'location_name', headerName: t("Report.phiLogs.Location"), colId: 'location_name' },
              { field: 'action_name', headerName: t("Report.auditTrail.action_title"), colId: 'action_name' },
              withClickableCell(
                { field: 'description', headerName: t("Location.Description"), colId: 'description', valueFormatter: (p) => this.renderDescriptionSummary(p.data) },
                (e, row) => this.handleDescriptionClick(e, row)
              ),
              { field: 'username', headerName: t("Report.inActive.UserName"), colId: 'username' },
              withDateColumnFilter({ field: 'created_on', headerName: t("Report.phiLogs.CreatedOn"), colId: 'created_on', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
      </div>
    );
  }
}

AuditReportComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(AuditReportComponent));




// WEBPACK FOOTER //
// ./src/components/reports/audit-report/index.js